export default __webpack_public_path__ + "static/media/worldtour3.ddc0602c.PNG";